<template>
  <div ref="QR" :style="style"/>
</template>

<script>
const QRCode = require('easyqrcodejs');

export default {
  name: 'QRCode',

  props: {
    value: { type: String, required: true },
    height: { type: Number, required: false, default: 200 },
    width: { type: Number, required: false, default: 200 },
  },

  computed: {
    style() {
      return `height: ${this.height}px; width: ${this.width}px`;
    },
  },

  mounted() {
    const el = this.$refs.QR;
    new QRCode(el, {
      text: this.value,
      height: this.height,
      width: this.width,
    });
  },
};
</script>
